module.exports = __webpack_public_path__ + "img/logo.b8b5b4f3.png";